import React, { useState }  from 'react';
import { Table, Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

export const BusTable = (props) => {

    const{
        busesData,
        formData,
        setFormData,
        loading,
        onDelete
    } =props;

    const [pagination, setPagination] = useState({ current: 1, pageSize: 5 });

    const busColumns = [
        {
            title: 'S.No',
            key: 'serial',
            width: 70,
            render: (_text, _record, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
        },
        {
            title: 'Bus Description',
            dataIndex: 'description',
            key: "center"
        },
        {
            title: 'A/C',
            dataIndex: 'isAc',
            key: "ac_field",
            render: (text) => {
                return text ? 'Yes' : 'No';
            }
        },
        {
            title: 'Coach Type',
            dataIndex: 'coach_type',
            key: "center",
        },
        {
            title: 'Seat Type',
            dataIndex: 'seat_type',
            key: "center",
        },
        {
            title: 'Seats',
            dataIndex: 'number_of_seats',
            key: "Seats_field",
        },
        {
            title: 'Action',
            key: 'action',
            align: 'center',
            render: (_text, record) => (
                <Button
                    type="text"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={(e) => {
                        e.stopPropagation();
                        onDelete && onDelete(record);
                    }}
                >
                    Delete
                </Button>
            ),
        }
    ]

    return (
        <div>
            <Table
            loading={loading}
            pagination={{ ...pagination }}
            onChange={(p) => setPagination({ current: p.current, pageSize: p.pageSize })}
            dataSource={busesData}
            columns={busColumns}
            onRow={(record, rowIndex) => {
                return {
                  onClick: event => {
                    setFormData(record);
                  }, // click row
                };
              }}
              rowClassName={(record, index)=>{
                let rowClassName="";
                    if(record.id== formData.id){
                        rowClassName=rowClassName+" TableRowClicked"
                    }
                    return  rowClassName
              }}
            />
        </div>
    );
}
